export const selectAllCheckbox = '[data-behaviour="select-all"][data-select-all-main="true"]';
export const eachCheckboxes = '[data-behaviour="select-all"][data-select-all-main!="true"]';

export default class SelectAllCheckboxes {
  init() {
    this.initCheckboxListeners();
  }

  initCheckboxListeners() {
    $(selectAllCheckbox).on('change', ({ currentTarget }) => {
      this.check(eachCheckboxes, currentTarget.checked);
    });

    $(eachCheckboxes).on('change', ({ currentTarget }) => {
      if (currentTarget.checked) {
        this.check(selectAllCheckbox, this.isEachChecked());
      } else {
        this.check(selectAllCheckbox, false);
      }
    });
  }

  check = (checkboxesSelector, checked) => {
    Array.from($(checkboxesSelector)).forEach((checkbox) => { $(checkbox).prop('checked', checked) });
  }

  isEachChecked() {
    return Array.from($(eachCheckboxes)).every((checkbox) => { return $(checkbox).prop('checked') });
  }

  isSomeChecked() {
    return Array.from($(eachCheckboxes)).some((checkbox) => { return $(checkbox).prop('checked') });
  }
}
